import React, { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Link } from "../../../../components/Text";
import {
  socialPlatformUrls,
  SocialPlatforms,
  socialPlatformIcons,
  socialBrandColors,
} from "../../../../constants/SocialPlatforms";
import { Show } from "../../ListingPage";

export interface UserInfoProps {
  show: Show;
  variant?: "square" | "circle";
}

const UserInfo: React.FC<UserInfoProps> = ({ show, variant = "circle" }) => {
  const [user, setUser] = useState<string>();
  // useEffect(() => {
  //   async function getUser() {
  //     const response = await fetch(
  //       `https://www.instagram.com/${username}/?__a=1`
  //     );
  //     const data = await response.json();
  //     setUser(data.graphql.user.profile_pic_url_hd);
  //   }
  //   if (platform === "ig") {
  //     getUser();
  //   }

  //   if (platform === "tw" && !photo) {
  //     (async function getUser() {
  //       const response = await fetch(
  //         `https://api.twitch.tv/helix/users?login=${username}`,
  //         {
  //           method: "GET",
  //           headers: {
  //             "Client-ID": "eo09uxd52vln7jis3a4ownnx0skq1k",
  //             // Authorization: "bearer " + data.access_token
  //           },
  //         }
  //       );
  //       const data = await response.json();
  //       if (data.data.length) {
  //         setUser(data.data[0].profile_image_url);
  //       }
  //     })();
  //   }
  // }, []);

  const url =
    show.videoUrl ||
    `${socialPlatformUrls[show.platform]}${show.user.username}`;

  return (
    <LinkStlyed target="_blank" className={variant} href={url}>
      <ImgThumb className={show.platform}>
        <img alt={show.user.username} src={user || show.user.photo} />
        <FontAwesomeIcon
          icon={socialPlatformIcons[show.platform]}
          className={show.platform + " platform-icon"}
        />
      </ImgThumb>
      <StartedTime>{show.time.start.toLocaleString()}</StartedTime>
      <div>
        <FontAwesomeIcon icon={socialPlatformIcons[show.platform]} size="lg" />{" "}
        {show.user.username}
      </div>
      <ShowTitle>{show.title}</ShowTitle>
    </LinkStlyed>
  );
};

export default UserInfo;

const ShowTitle = styled.h4`
  font-size: 18px;
  margin: 0;
  margin-top: 16px;
  font-weight: 600;
`;
const StartedTime = styled.p`
  color: #666;
  margin: 0;
  margin-bottom: 4px;
  font-size: 14px;
`;

const ImgThumb = styled.div`
  width: 100%;
  overflow: hidden;
  padding-top: 56%;
  position: relative;
  margin: 16px auto;
  transition: transform ease 0.1s, box-shadow ease 0.1s;

  &.yt,
  .yt {
    background: ${socialBrandColors.yt};
  }

  &.ig,
  .ig {
    background: ${socialBrandColors.ig};
    background: -moz-linear-gradient(
      45deg,
      #f09433 0%,
      #e6683c 25%,
      #dc2743 50%,
      #cc2366 75%,
      #bc1888 100%
    );
    background: -webkit-linear-gradient(
      45deg,
      #f09433 0%,
      #e6683c 25%,
      #dc2743 50%,
      #cc2366 75%,
      #bc1888 100%
    );
    background: linear-gradient(
      45deg,
      #f09433 0%,
      #e6683c 25%,
      #dc2743 50%,
      #cc2366 75%,
      #bc1888 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f09433', endColorstr='#bc1888',GradientType=1 );
  }

  &.fb,
  .fb {
    background: ${socialBrandColors.fb};
  }

  &.tw,
  .tw {
    background: ${socialBrandColors.tw};
  }

  img {
    height: 100%;
    width: 100%;
    display: block;
    object-fit: cover;
    background: lightgray;
    position: absolute;
    left: 5px;
    top: 0;
  }

  .platform-icon {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 5px;
    font-size: 32px;
    color: #fff;
  }
`;

const LinkStlyed = styled(Link)`
  transition: color ease 0.1s;
  color: #ccc;
  size: 16px;
  width: 100%;
  &:hover {
    color: #fff;

    ${ImgThumb} {
      box-shadow: 0px 0px 11px 0px #999999;
      transform: scale(1.025);
    }
  }

  ${ImgThumb} {
    img {
      width: 100%;
    }
  }
`;
